if (!customElements.get('cart-gift')) {
    class CartGift extends HTMLElement {
        constructor() {
            super();
            this.giftCheckbox = this.querySelector('.js-cart-gift-checkbox');
            this.form = this.getCartForm();
            
            this.giftCheckbox.addEventListener('change', this.handleGiftToggle.bind(this));
            
            // Solo añadir event listener al form si existe
            if (this.form) {
                this.form.addEventListener('submit', this.handleSubmit.bind(this));
            }
            
            // Verificar estado inicial
            this.checkInitialState();
            
            // Escuchar actualizaciones del carrito para sincronizar estado
            document.addEventListener('cart:updated', this.syncGiftState.bind(this));
        }

        /**
         * Obtiene el formulario del carrito correcto dependiendo del contexto
         */
        getCartForm() {
            const formId = this.giftCheckbox.getAttribute('form');
            let form = null;
            
            if (formId) {
                form = document.getElementById(formId);
            }
            
            // Fallback: buscar formularios comunes del carrito
            if (!form) {
                form = document.getElementById('cart') || 
                       document.getElementById('drawer-cart-form') ||
                       document.querySelector('form[action*="/cart"]');
            }
            
            return form;
        }

        /**
         * Verifica el estado inicial basado en los atributos del carrito
         */
        checkInitialState() {
            // Verificar si ya existe la etiqueta REGALO en el carrito
            const isGift = this.isCurrentlyGift();
            
            if (isGift) {
                this.giftCheckbox.checked = true;
            }
        }

        /**
         * Verifica si el carrito actual tiene el atributo de regalo
         */
        isCurrentlyGift() {
            // Buscar en inputs hidden existentes
            const giftInput = document.querySelector('input[name="attributes[Es regalo]"]');
            if (giftInput && giftInput.value === 'REGALO') {
                return true;
            }
            
            // Verificar en la URL
            if (window.location.search.includes('attributes[Es regalo]=REGALO') || 
                window.location.search.includes('attributes[Es regalo]=true')) {
                return true;
            }
            
            // Verificar en el objeto cart de Shopify si está disponible
            if (window.cart && window.cart.attributes && window.cart.attributes['Es regalo'] === 'REGALO') {
                return true;
            }
            
            return false;
        }

        /**
         * Sincroniza el estado del checkbox con el carrito actualizado
         */
        syncGiftState(event) {
            if (event.detail && event.detail.cart && event.detail.cart.attributes) {
                const isGift = event.detail.cart.attributes['Es regalo'] === 'REGALO';
                this.giftCheckbox.checked = isGift;
            }
        }

        /**
         * Maneja el toggle del checkbox de regalo
         */
        handleGiftToggle() {
            if (this.giftCheckbox.checked) {
                this.addGiftAttribute();
            } else {
                this.removeGiftAttribute();
            }
        }

        /**
         * Añade el atributo de regalo al carrito
         */
        addGiftAttribute() {
            // Crear o actualizar el campo hidden para el atributo "Es regalo"
            let giftInput = this.getOrCreateGiftInput();
            giftInput.value = 'REGALO';

            // Actualizar el carrito inmediatamente
            this.updateCart();
        }

        /**
         * Remueve el atributo de regalo del carrito
         */
        removeGiftAttribute() {
            let giftInput = this.getOrCreateGiftInput();
            giftInput.value = '';

            // Actualizar el carrito inmediatamente
            this.updateCart();
        }

        /**
         * Obtiene o crea el input hidden para el atributo de regalo
         */
        getOrCreateGiftInput() {
            let giftInput = document.querySelector('input[name="attributes[Es regalo]"]');
            
            if (!giftInput && this.form) {
                giftInput = document.createElement('input');
                giftInput.type = 'hidden';
                giftInput.name = 'attributes[Es regalo]';
                this.form.appendChild(giftInput);
            }
            
            return giftInput;
        }

        /**
         * Actualiza el carrito con los nuevos atributos
         */
        updateCart() {
            // Preparar los atributos
            const attributes = {
                'Es regalo': this.giftCheckbox.checked ? 'REGALO' : ''
            };

            // Recopilar otros atributos existentes del formulario si existe
            if (this.form) {
                const formData = new FormData(this.form);
                for (const [key, value] of formData.entries()) {
                    if (key.startsWith('attributes[')) {
                        const attributeName = key.replace('attributes[', '').replace(']', '');
                        if (attributeName !== 'Es regalo') {
                            attributes[attributeName] = value;
                        }
                    }
                }
            }
            
            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                    attributes: attributes
                })
            })
            .then(response => response.json())
            .then(cart => {
                // Actualizar el objeto cart global si existe
                if (window.cart) {
                    window.cart = cart;
                }
                
                // Disparar evento personalizado para notificar que el carrito se actualizó
                document.dispatchEvent(new CustomEvent('cart:updated', {
                    detail: { cart: cart }
                }));
                
                // Sincronizar otros checkboxes de regalo en la página
                this.syncOtherGiftCheckboxes();
            })
            .catch(error => {
                console.error('Error updating cart:', error);
                // Revertir el checkbox en caso de error
                this.giftCheckbox.checked = !this.giftCheckbox.checked;
            });
        }

        /**
         * Sincroniza otros checkboxes de regalo en la página
         */
        syncOtherGiftCheckboxes() {
            const otherCheckboxes = document.querySelectorAll('.js-cart-gift-checkbox');
            otherCheckboxes.forEach(checkbox => {
                if (checkbox !== this.giftCheckbox) {
                    checkbox.checked = this.giftCheckbox.checked;
                }
            });
        }

        /**
         * Maneja el envío del formulario
         */
        handleSubmit(evt) {
            // Asegurar que los atributos estén actualizados antes del checkout
            if (this.giftCheckbox.checked) {
                let giftInput = this.getOrCreateGiftInput();
                if (giftInput) {
                    giftInput.value = 'REGALO';
                }
            }
        }
    }

    customElements.define('cart-gift', CartGift);
}

// Función auxiliar para sincronizar checkboxes cuando se carga la página
document.addEventListener('DOMContentLoaded', function() {
    // Sincronizar estado inicial de todos los checkboxes de regalo
    const giftCheckboxes = document.querySelectorAll('.js-cart-gift-checkbox');
    if (giftCheckboxes.length > 1) {
        const firstCheckbox = giftCheckboxes[0];
        const isChecked = firstCheckbox.checked;
        
        giftCheckboxes.forEach(checkbox => {
            checkbox.checked = isChecked;
        });
    }
});